import appSettings from 'wanderu-config';
import { SnowplowService } from 'wanderu-service-analytics';

function tripLivecheckCompleted({
    label,
    tripId,
    itineraryId,
    lastScraped,
    price,
    priceDifference,
}) {
    if (!appSettings.env.isClient) {
        return;
    }

    SnowplowService.fireStructuredEvent({
        category: 'react_livecheck',
        action: 'cached_trip_completed',
        label,
        property: {
            trip_id: tripId,
            itinerary_id: itineraryId,
            last_scraped: lastScraped,
            price: price,
            price_difference: priceDifference,
        },
    });
}

export default {
    tripLivecheckCompleted,
};
